<template>
    <div class="amountDetailModal" v-if="price && price.currentAmount">
        <bottomModal cla="rightXClose full auto-height bg-f5f5f5" ref="amountDetailModal">
            <div class="flex align-center justify-start text-white">
              ￥
              <div class="text-600" style="font-size: 24px;">{{ price.currentAmount / 100 }}</div>
              <div class="buy-box-sub margin-left-sm">明细<span class="cuIcon-right"></span></div>
            </div>
            <div slot="part" class="padding-top-xl text-lg">
              <div class="text-600 text-center" style="font-size: 16px">金额明细</div>
              <div class="margin-lr-sm bg-white radius margin-top-lg padding-lr-sm padding-top-lg padding-bottom-xl">
                <div>
                  <div class="flex align-center justify-between">
                    <div>订单原价</div>
                    <div>¥{{ price.originalAmount>0 ? price.originalAmount / 100 : price.originAmount / 100 }}</div>
                  </div>
                  <template v-for="dl in price.discountList">
                    <div class="flex align-center justify-between margin-top-lg" v-if="dl.discountType == '折扣'">
                      <div>{{ dl.discount == 1 ? '免费版无折扣' : ('会员折扣' + discount(dl.discount) + '折') }}</div>
                      <div class="text-red">-¥{{ dl.amount / 100 }}</div>
                    </div>
                    <div class="flex align-center justify-between margin-top-lg" v-else="">
                      <div>{{ discountTypes[dl.discountType] || dl.discountType }}</div>
                      <div class="text-red">-¥{{ dl.amount / 100 }}</div>
                    </div>
                  </template>
                  <template v-if="price.serviceFeeAmount>0">
                    <virtualPayModal :hasDisplayTitle="false">
                      <div class="flex align-center justify-between margin-top-lg">
                          <div class="flex">支付技术服务费&nbsp;<span class="cuIcon-question text-gray"></span></div>
                          <div class="">¥{{price.serviceFeeAmount/100}}</div>
                      </div>
                    </virtualPayModal>
                      
                  </template>
                </div>
                <div class="flex align-center justify-end" style="margin-top: 70px;">
                  <div class="text-df text-500">合计</div>
                  <div class="margin-left-sm" style="font-size: 18px;">¥{{ (price.currentAmount) / 100 }}</div>
                </div>
              </div>
              <div class="overbox padding-top-lg">
                <div class="overbox-but" @click="amountDetailModalHide">确定</div>
              </div>
            </div>
          </bottomModal>
    </div>

</template>

<script>
import App from '../util/comfun'
import Env from '../util/env'
import BottomModal from './common/bottom-modal.vue';
import virtualPayModal from './virtualPayModal.vue'
export default {
    components: {
        BottomModal,
        virtualPayModal,
    },
    name: 'AmountDetailModal',
    props: {
        // Define your props here
        price: {//订单金额信息
            type: Object,
            default: null,
        }
    },
    data() {
        return {
          discountTypes:{
            "抵扣金额":'原会员抵扣金额',
          },
            // Component state
            hasVirtualPay: false,//是否显示支付技术服务费弹窗
        };
    },
    methods: {
        // Component methods
        show() {
            this.$refs.amountDetailModal.show();
        },
        hide() {        
            this.$refs.amountDetailModal.hide();
        },
        init(){
             
        },
        amountDetailModalHide() {
            this.hide();
        },
        discount(discount) {
            if (!discount) return ''
            return ((discount * 10) + '').replace(/\./g, '')
        },
    },
    mounted() {
        // Lifecycle hook
        this.init();

    }
};
</script>

<style scoped>
@import "../../static/icon.css";
@import "../../static/buy-x.css";


</style>


// WEBPACK FOOTER //
// src/components/amountDetailModal.vue